import { handleUpdateDescription } from "../document-actions";
/**
 * Applies a project description action by updating the document description
 * @param action The project description action to apply
 * @param dependencies The dependencies needed to apply the action
 * @returns A promise that resolves to the result of applying the action
 */
export function applyProjectDescriptionAction(action, document) {
    handleUpdateDescription(document, action);
    return {
        projectDescription: document.description,
    };
}
//# sourceMappingURL=applyProjectDescriptionAction.js.map